'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { getContext } from '../../direct-contact'
import { useGlobalConfigContext } from '../../global-config'
import { urlResolverGetAccountOrders } from '../../url-handling'
import { otherTopicsContactGtmPushTrackFullStoryPageLoad } from '../gtm/event/otherTopicsContactGtmPushTrackFullStoryPageLoad'

export const useOtherTopicsContactFullStoryTracking = (): void => {
  const config = useGlobalConfigContext()
  const orderUrl = urlResolverGetAccountOrders(config)
  const searchParams = useSearchParams()

  useEffect(() => {
    const context = getContext(searchParams, orderUrl)
    otherTopicsContactGtmPushTrackFullStoryPageLoad(context)
  }, [orderUrl, searchParams])
}
